// Cgv.js
import React from 'react';
import './PageContainer.css';


function Cgv() {
  return (
    <div className="page-container">
      <h1>Conditions Générales de Vente (CGV)</h1>
      <h2>1. Objet</h2>
      <p>Les présentes CGV régissent les relations contractuelles entre CICJ IMMO et ses clients pour toutes prestations immobilières, juridiques, techniques ou BTP.</p>
      <h2>2. Acceptation des conditions</h2>
      <p>Toute commande implique l’acceptation sans réserve des présentes CGV.</p>
      <h2>3. Prestations proposées</h2>
      <ul>
        <li>Gestion locative</li>
        <li>Mise en relation pour vente/location</li>
        <li>Études techniques</li>
        <li>Consultance juridique</li>
        <li>Projets BTP</li>
      </ul>
      <h2>4. Modalités de paiement</h2>
      <ul>
        <li>Acompte à la commande</li>
        <li>Solde à la livraison</li>
        <li>Paiement échelonné possible</li>
        <li>Espèces, Mobile Money, virement, chèque certifié</li>
      </ul>
      <h2>5. Obligations du client</h2>
      <ul>
        <li>Fournir les informations nécessaires</li>
        <li>Respecter les délais de paiement</li>
        <li>Faciliter l’accès au bien</li>
        <li>Signaler toute modification</li>
      </ul>
      <h2>6. Annulation ou modification</h2>
      <p>Annulation après début des travaux : acompte conservé. Modification : ajustement possible du tarif/délai.</p>
      <h2>7. Responsabilité</h2>
      <p>CICJ n’est pas responsable en cas de force majeure, faute client ou défaillance d’un tiers non mandaté.</p>
      <h2>8. Confidentialité</h2>
      <p>Les échanges entre CICJ et le client sont confidentiels, sauf obligation légale.</p>
      <h2>9. Droit applicable</h2>
      <p>Loi sénégalaise. En cas de litige : médiation d’abord, tribunal de Thiès ou Dakar ensuite.</p>
    </div>
  );
}

export default Cgv;
